import { useState } from 'react'
import { MeetingStartTimes } from '@chilipiper/booking-flow'

export const useStartTimes = (
  timeSlots?: MeetingStartTimes,
  suggestedTimes?: Array<string>,
  meetingStartTime?: string
) => {
  const suggestedTimeSlots: (MeetingStartTimes & { isSuggestedTimes: boolean }) | undefined =
    suggestedTimes
      ? {
          meetingTypeRef: {
            id: timeSlots?.meetingTypeRef.id ?? '',
            timestamp: timeSlots?.meetingTypeRef.timestamp ?? '',
          },
          startTimes: suggestedTimes,
          failures: {},
          userIds: [],
          isSuggestedTimes: true,
        }
      : undefined
  const [ignoreSuggestedTimes, setIgnoreSuggestedTimes] = useState(false)

  const slots = ignoreSuggestedTimes ? timeSlots : (suggestedTimeSlots ?? timeSlots)
  const startTimeWithoutSelectedOne = slots?.startTimes?.filter(time => {
    if (!meetingStartTime) return true
    if (typeof time === 'string') {
      return new Date(time).getTime() !== new Date(meetingStartTime).getTime()
    }
    return new Date(time.startTime).getTime() !== new Date(meetingStartTime).getTime()
  })

  return {
    startTimes: { ...slots, startTimes: startTimeWithoutSelectedOne } as MeetingStartTimes,
    ignoreSuggestedTimes,
    toggleIgnoreSuggestedTimes: () => setIgnoreSuggestedTimes(prevState => !prevState),
  }
}
